var map = {
	"./cs/settings.json": 3256,
	"./de/settings.json": 931,
	"./en/settings.json": 5919,
	"./es/settings.json": 6542,
	"./fr/settings.json": 9286,
	"./it/settings.json": 4489,
	"./pl/settings.json": 1786,
	"./ru/settings.json": 585,
	"./tr/settings.json": 1584,
	"./uk/settings.json": 7238,
	"./zh-CN/settings.json": 9266,
	"./zh-TW/settings.json": 1950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3973;